import { useState, type ReactNode } from "react";
import { FormattedMessage } from "react-intl";

import { useTagUserMutation } from "common/user/tag";
import AlertMessage from "common/core/alert_message";
import Link from "common/core/link";
import { newIaAnnouncementUrl } from "constants/marketing";
import { captureException } from "util/exception";

import type { ProofFrame_viewer_user as User } from "../index.query.graphql";

type LaunchBannerProps = {
  user: User;
};

const LAUNCH_BANNER_TAG = "new-ia-launch-banner";
export function LaunchBanner({ user }: LaunchBannerProps) {
  const { id: userId } = user;
  const bannerTags = user.tags?.filter((tag) => tag?.tag === LAUNCH_BANNER_TAG);
  const [showBanner, setShowBanner] = useState(Boolean(bannerTags?.length === 0));

  const tagUserMutateFn = useTagUserMutation();
  const handleDismissBanner = () => {
    setShowBanner(false);
    try {
      tagUserMutateFn({
        variables: {
          input: {
            userId,
            tag: LAUNCH_BANNER_TAG,
          },
          userTagList: [LAUNCH_BANNER_TAG],
        },
      });
    } catch {
      captureException(new Error(`Error tagging ia launch banner for user ${userId}`));
    }
  };

  return showBanner ? (
    <AlertMessage banner kind="announcement" centerText onClose={handleDismissBanner}>
      <FormattedMessage
        id="b7533d4f-0467-4ca0-8306-bf9ee5abcdb8"
        defaultMessage="<newLook>New look, better navigation!</newLook>We've made changes to make Notarize even easier to use. <learnMore>Learn more</learnMore>"
        values={{
          newLook: (text: ReactNode) => <strong>{text}&nbsp;</strong>,
          learnMore: (text: ReactNode) => (
            <>
              &nbsp;
              <Link white href={newIaAnnouncementUrl}>
                {text}
              </Link>
            </>
          ),
        }}
      />
    </AlertMessage>
  ) : null;
}
